import React from 'react';
import { RadixHoverDropdown, FormFieldV2 as FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface OtherTabProps {
  formMode: FormMode;
}

export const OtherTab: React.FC<OtherTabProps> = ({ formMode }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Số c/từ(từ/đến)</Label>
          <FormField type='text' name='so_ct1' disabled={formMode === 'view'} />
          <FormField type='text' name='so_ct2' disabled={formMode === 'view'} className='ml-2' />
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Mẫu lọc báo cáo:</Label>
          <div className='flex items-center gap-1'>
            <FormField
              name='report_filtering'
              type='select'
              options={[{ value: '0', label: 'Người dùng tự lọc' }]}
              defaultValue={'0'}
              className='w-96'
            />

            <div className='flex-shrink-0'>
              {/* Fixed size container */}
              <RadixHoverDropdown
                iconNumber={624}
                items={[
                  {
                    value: 'save_new',
                    label: 'Lưu mẫu mới',
                    icon: 7,
                    onClick: () => undefined
                  },
                  {
                    value: 'save_overwrite',
                    label: 'Lưu đè vào mẫu đang chọn',
                    icon: 75,
                    onClick: () => console.log('Overwrite current filter template')
                  },
                  {
                    value: 'delete',
                    label: 'Xóa mẫu đang chọn',
                    icon: 8,
                    onClick: () => console.log('Delete current filter template')
                  }
                ]}
              />
            </div>
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Mẫu phân tích DL:</Label>
          <div className='flex items-center gap-1'>
            <FormField
              name='data_analysis_struct'
              type='select'
              options={[{ value: '0', label: 'Không phân tích' }]}
              defaultValue={'0'}
              className='w-96'
            />

            <div className='flex-shrink-0'>
              {/* Fixed size container */}
              <RadixHoverDropdown
                iconNumber={790}
                items={[
                  {
                    value: 'save_new',
                    label: 'Lưu mẫu mới',
                    icon: 7,
                    onClick: () => undefined
                  },
                  {
                    value: 'save_overwrite',
                    label: 'Sửa mẫu đang chọn',
                    icon: 9,
                    onClick: () => console.log('Overwrite current filter template')
                  },
                  {
                    value: 'delete',
                    label: 'Xóa mẫu đang chọn',
                    icon: 8,
                    onClick: () => console.log('Delete current filter template')
                  }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
